<template>
  <a v-if="showComponent"
     :title="qaAble ? showIfHasPermission?.toString() : null"
     :key="componentRefresh"
     :class="['dropdown-item',classes]"
     href=""
     @click.prevent="onClick"
     :disabled="!enableComponent || disabled"
  >
    {{ label }} <i :class="[classIcon]" v-if="classIcon"></i>
  </a>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: "ks-button-option",
  mixins: [checkPermissions],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    classIcon: {
      type: String,
      default: null
    },
    classes: {
      type: String,
      default: null
    },
    push: {
      default: null
    }
  },
  methods: {
    onClick(params) {
      if (this.push) {
        let redirect = typeof this.push == 'object' ? this.push : {path: this.push};
        this.$router.push(redirect);
        this.$emit('onPush', {event: params, push: this.push});
      } else this.$emit('onClick', params);
    }
  },
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },

}
</script>
